/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * Fleet and operations management API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ArrivalRequest,
  AssignServiceRequest,
  Business,
  BusinessListResponse,
  Client,
  ClientListResponse,
  CompleteServiceRequest,
  CreateBusinessRequest,
  CreateClientRequest,
  CreateLocationRequest,
  CreatePersonnelRequest,
  CreateServiceRequest,
  CreateServiceTypeRequest,
  CreateTrailerRequest,
  CreateTrailerTypeRequest,
  CreateVehicleRequest,
  CreateVehicleTypeRequest,
  CreateWasteTypeRequest,
  DailyScheduleResponse,
  DashboardSummary,
  ErrorResponse,
  ExpiringDocumentsResponse,
  GetDailyScheduleParams,
  GetDashboardSummaryParams,
  GetExpiringDocumentsParams,
  GetServicesByDayParams,
  GetServicesByTypeParams,
  GetTopClientsParams,
  HealthStatus,
  IncidentRequest,
  LegCompleteRequest,
  ListBusinessesParams,
  ListClientsParams,
  ListLocationsParams,
  ListPersonnelParams,
  ListServiceTypesParams,
  ListServicesParams,
  ListTrailerTypesParams,
  ListTrailersParams,
  ListVehicleTypesParams,
  ListVehiclesParams,
  ListWasteTypesParams,
  Location,
  LocationListResponse,
  LoginRequest,
  LoginResponse,
  PersonnelItem,
  PersonnelListResponse,
  PresignRequest,
  PresignResponse,
  RefreshTokenRequest,
  RejectServiceRequest,
  CancelServiceRequest,
  RescheduleServiceRequest,
  RescheduleServiceResponse,
  ReplaceLegsRequest,
  ServiceDetail,
  ServiceEvent,
  ServiceEventListResponse,
  ServiceLeg,
  ServiceLegsResponse,
  ServiceListResponse,
  ServiceType,
  ServiceTypeListResponse,
  ServicesByDayResponse,
  ServicesByTypeResponse,
  TopClientsResponse,
  Trailer,
  TrailerListResponse,
  TrailerTypeItem,
  TrailerTypeItemListResponse,
  UpdateBusinessRequest,
  UpdateClientRequest,
  UpdateLocationRequest,
  UpdatePersonnelRequest,
  UpdateServiceRequest,
  UpdateServiceTypeRequest,
  UpdateTrailerRequest,
  UpdateTrailerTypeRequest,
  UpdateVehicleRequest,
  UpdateVehicleTypeRequest,
  UpdateWasteTypeRequest,
  UserProfile,
  Vehicle,
  VehicleListResponse,
  VehicleTypeItem,
  VehicleTypeItemListResponse,
  WasteType,
  WasteTypeListResponse,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Returns server health status
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/health`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/health`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Login with email+password (web) or legajo+PIN (driver)
 * @summary Login
 */
export const getLoginUrl = () => {
  return `/api/auth/login`;
};

export const login = async (
  loginRequest: LoginRequest,
  options?: RequestInit,
): Promise<LoginResponse> => {
  return customFetch<LoginResponse>(getLoginUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(loginRequest),
  });
};

export const getLoginMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginRequest> },
  TContext
> => {
  const mutationKey = ["login"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof login>>,
    { data: BodyType<LoginRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return login(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof login>>
>;
export type LoginMutationBody = BodyType<LoginRequest>;
export type LoginMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Login
 */
export const useLogin = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginRequest> },
  TContext
> => {
  return useMutation(getLoginMutationOptions(options));
};

/**
 * @summary Refresh access token
 */
export const getRefreshTokenUrl = () => {
  return `/api/auth/refresh`;
};

export const refreshToken = async (
  refreshTokenRequest: RefreshTokenRequest,
  options?: RequestInit,
): Promise<LoginResponse> => {
  return customFetch<LoginResponse>(getRefreshTokenUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(refreshTokenRequest),
  });
};

export const getRefreshTokenMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshToken>>,
    TError,
    { data: BodyType<RefreshTokenRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshToken>>,
  TError,
  { data: BodyType<RefreshTokenRequest> },
  TContext
> => {
  const mutationKey = ["refreshToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshToken>>,
    { data: BodyType<RefreshTokenRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return refreshToken(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshToken>>
>;
export type RefreshTokenMutationBody = BodyType<RefreshTokenRequest>;
export type RefreshTokenMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Refresh access token
 */
export const useRefreshToken = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshToken>>,
    TError,
    { data: BodyType<RefreshTokenRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof refreshToken>>,
  TError,
  { data: BodyType<RefreshTokenRequest> },
  TContext
> => {
  return useMutation(getRefreshTokenMutationOptions(options));
};

/**
 * @summary Logout
 */
export const getLogoutUrl = () => {
  return `/api/auth/logout`;
};

export const logout = async (options?: RequestInit): Promise<void> => {
  return customFetch<void>(getLogoutUrl(), {
    ...options,
    method: "POST",
  });
};

export const getLogoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["logout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logout>>,
    void
  > = () => {
    return logout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof logout>>
>;

export type LogoutMutationError = ErrorType<unknown>;

/**
 * @summary Logout
 */
export const useLogout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getLogoutMutationOptions(options));
};

/**
 * @summary Get current user
 */
export const getGetMeUrl = () => {
  return `/api/auth/me`;
};

export const getMe = async (options?: RequestInit): Promise<UserProfile> => {
  return customFetch<UserProfile>(getGetMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMeQueryKey = () => {
  return [`/api/auth/me`] as const;
};

export const getGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({
    signal,
  }) => getMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get current user
 */

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List clients
 */
export const getListClientsUrl = (params?: ListClientsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/clients?${stringifiedParams}`
    : `/api/clients`;
};

export const listClients = async (
  params?: ListClientsParams,
  options?: RequestInit,
): Promise<ClientListResponse> => {
  return customFetch<ClientListResponse>(getListClientsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListClientsQueryKey = (params?: ListClientsParams) => {
  return [`/api/clients`, ...(params ? [params] : [])] as const;
};

export const getListClientsQueryOptions = <
  TData = Awaited<ReturnType<typeof listClients>>,
  TError = ErrorType<unknown>,
>(
  params?: ListClientsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listClients>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListClientsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listClients>>> = ({
    signal,
  }) => listClients(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listClients>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListClientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listClients>>
>;
export type ListClientsQueryError = ErrorType<unknown>;

/**
 * @summary List clients
 */

export function useListClients<
  TData = Awaited<ReturnType<typeof listClients>>,
  TError = ErrorType<unknown>,
>(
  params?: ListClientsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listClients>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListClientsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create client
 */
export const getCreateClientUrl = () => {
  return `/api/clients`;
};

export const createClient = async (
  createClientRequest: CreateClientRequest,
  options?: RequestInit,
): Promise<Client> => {
  return customFetch<Client>(getCreateClientUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createClientRequest),
  });
};

export const getCreateClientMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClient>>,
    TError,
    { data: BodyType<CreateClientRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createClient>>,
  TError,
  { data: BodyType<CreateClientRequest> },
  TContext
> => {
  const mutationKey = ["createClient"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createClient>>,
    { data: BodyType<CreateClientRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createClient(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateClientMutationResult = NonNullable<
  Awaited<ReturnType<typeof createClient>>
>;
export type CreateClientMutationBody = BodyType<CreateClientRequest>;
export type CreateClientMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create client
 */
export const useCreateClient = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClient>>,
    TError,
    { data: BodyType<CreateClientRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createClient>>,
  TError,
  { data: BodyType<CreateClientRequest> },
  TContext
> => {
  return useMutation(getCreateClientMutationOptions(options));
};

/**
 * @summary Get client by ID
 */
export const getGetClientUrl = (id: string) => {
  return `/api/clients/${id}`;
};

export const getClient = async (
  id: string,
  options?: RequestInit,
): Promise<Client> => {
  return customFetch<Client>(getGetClientUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetClientQueryKey = (id: string) => {
  return [`/api/clients/${id}`] as const;
};

export const getGetClientQueryOptions = <
  TData = Awaited<ReturnType<typeof getClient>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getClient>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClient>>> = ({
    signal,
  }) => getClient(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getClient>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetClientQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClient>>
>;
export type GetClientQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get client by ID
 */

export function useGetClient<
  TData = Awaited<ReturnType<typeof getClient>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getClient>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetClientQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update client
 */
export const getUpdateClientUrl = (id: string) => {
  return `/api/clients/${id}`;
};

export const updateClient = async (
  id: string,
  updateClientRequest: UpdateClientRequest,
  options?: RequestInit,
): Promise<Client> => {
  return customFetch<Client>(getUpdateClientUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateClientRequest),
  });
};

export const getUpdateClientMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClient>>,
    TError,
    { id: string; data: BodyType<UpdateClientRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateClient>>,
  TError,
  { id: string; data: BodyType<UpdateClientRequest> },
  TContext
> => {
  const mutationKey = ["updateClient"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateClient>>,
    { id: string; data: BodyType<UpdateClientRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateClient(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateClientMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateClient>>
>;
export type UpdateClientMutationBody = BodyType<UpdateClientRequest>;
export type UpdateClientMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update client
 */
export const useUpdateClient = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClient>>,
    TError,
    { id: string; data: BodyType<UpdateClientRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateClient>>,
  TError,
  { id: string; data: BodyType<UpdateClientRequest> },
  TContext
> => {
  return useMutation(getUpdateClientMutationOptions(options));
};

/**
 * @summary Soft-delete client (sets activo=false)
 */
export const getDeleteClientUrl = (id: string) => {
  return `/api/clients/${id}`;
};

export const deleteClient = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteClientUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteClientMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClient>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteClient>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteClient"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteClient>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteClient(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteClientMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteClient>>
>;

export type DeleteClientMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Soft-delete client (sets activo=false)
 */
export const useDeleteClient = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClient>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteClient>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteClientMutationOptions(options));
};

/**
 * @summary List businesses
 */
export const getListBusinessesUrl = (params?: ListBusinessesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/businesses?${stringifiedParams}`
    : `/api/businesses`;
};

export const listBusinesses = async (
  params?: ListBusinessesParams,
  options?: RequestInit,
): Promise<BusinessListResponse> => {
  return customFetch<BusinessListResponse>(getListBusinessesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListBusinessesQueryKey = (params?: ListBusinessesParams) => {
  return [`/api/businesses`, ...(params ? [params] : [])] as const;
};

export const getListBusinessesQueryOptions = <
  TData = Awaited<ReturnType<typeof listBusinesses>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBusinessesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBusinesses>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBusinessesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBusinesses>>> = ({
    signal,
  }) => listBusinesses(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBusinesses>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBusinessesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBusinesses>>
>;
export type ListBusinessesQueryError = ErrorType<unknown>;

/**
 * @summary List businesses
 */

export function useListBusinesses<
  TData = Awaited<ReturnType<typeof listBusinesses>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBusinessesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBusinesses>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListBusinessesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create business
 */
export const getCreateBusinessUrl = () => {
  return `/api/businesses`;
};

export const createBusiness = async (
  createBusinessRequest: CreateBusinessRequest,
  options?: RequestInit,
): Promise<Business> => {
  return customFetch<Business>(getCreateBusinessUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createBusinessRequest),
  });
};

export const getCreateBusinessMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBusiness>>,
    TError,
    { data: BodyType<CreateBusinessRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBusiness>>,
  TError,
  { data: BodyType<CreateBusinessRequest> },
  TContext
> => {
  const mutationKey = ["createBusiness"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBusiness>>,
    { data: BodyType<CreateBusinessRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createBusiness(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBusinessMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBusiness>>
>;
export type CreateBusinessMutationBody = BodyType<CreateBusinessRequest>;
export type CreateBusinessMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create business
 */
export const useCreateBusiness = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBusiness>>,
    TError,
    { data: BodyType<CreateBusinessRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBusiness>>,
  TError,
  { data: BodyType<CreateBusinessRequest> },
  TContext
> => {
  return useMutation(getCreateBusinessMutationOptions(options));
};

/**
 * @summary Get business by ID
 */
export const getGetBusinessUrl = (id: string) => {
  return `/api/businesses/${id}`;
};

export const getBusiness = async (
  id: string,
  options?: RequestInit,
): Promise<Business> => {
  return customFetch<Business>(getGetBusinessUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetBusinessQueryKey = (id: string) => {
  return [`/api/businesses/${id}`] as const;
};

export const getGetBusinessQueryOptions = <
  TData = Awaited<ReturnType<typeof getBusiness>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBusiness>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBusinessQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusiness>>> = ({
    signal,
  }) => getBusiness(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBusiness>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBusinessQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBusiness>>
>;
export type GetBusinessQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get business by ID
 */

export function useGetBusiness<
  TData = Awaited<ReturnType<typeof getBusiness>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBusiness>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBusinessQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update business
 */
export const getUpdateBusinessUrl = (id: string) => {
  return `/api/businesses/${id}`;
};

export const updateBusiness = async (
  id: string,
  updateBusinessRequest: UpdateBusinessRequest,
  options?: RequestInit,
): Promise<Business> => {
  return customFetch<Business>(getUpdateBusinessUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateBusinessRequest),
  });
};

export const getUpdateBusinessMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBusiness>>,
    TError,
    { id: string; data: BodyType<UpdateBusinessRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBusiness>>,
  TError,
  { id: string; data: BodyType<UpdateBusinessRequest> },
  TContext
> => {
  const mutationKey = ["updateBusiness"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBusiness>>,
    { id: string; data: BodyType<UpdateBusinessRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateBusiness(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBusinessMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBusiness>>
>;
export type UpdateBusinessMutationBody = BodyType<UpdateBusinessRequest>;
export type UpdateBusinessMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update business
 */
export const useUpdateBusiness = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBusiness>>,
    TError,
    { id: string; data: BodyType<UpdateBusinessRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateBusiness>>,
  TError,
  { id: string; data: BodyType<UpdateBusinessRequest> },
  TContext
> => {
  return useMutation(getUpdateBusinessMutationOptions(options));
};

/**
 * @summary Soft-delete business
 */
export const getDeleteBusinessUrl = (id: string) => {
  return `/api/businesses/${id}`;
};

export const deleteBusiness = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteBusinessUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteBusinessMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBusiness>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBusiness>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteBusiness"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBusiness>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteBusiness(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBusinessMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBusiness>>
>;

export type DeleteBusinessMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Soft-delete business
 */
export const useDeleteBusiness = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBusiness>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteBusiness>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteBusinessMutationOptions(options));
};

/**
 * @summary List locations
 */
export const getListLocationsUrl = (params?: ListLocationsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/locations?${stringifiedParams}`
    : `/api/locations`;
};

export const listLocations = async (
  params?: ListLocationsParams,
  options?: RequestInit,
): Promise<LocationListResponse> => {
  return customFetch<LocationListResponse>(getListLocationsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListLocationsQueryKey = (params?: ListLocationsParams) => {
  return [`/api/locations`, ...(params ? [params] : [])] as const;
};

export const getListLocationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listLocations>>,
  TError = ErrorType<unknown>,
>(
  params?: ListLocationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLocations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListLocationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listLocations>>> = ({
    signal,
  }) => listLocations(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLocations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListLocationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLocations>>
>;
export type ListLocationsQueryError = ErrorType<unknown>;

/**
 * @summary List locations
 */

export function useListLocations<
  TData = Awaited<ReturnType<typeof listLocations>>,
  TError = ErrorType<unknown>,
>(
  params?: ListLocationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLocations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListLocationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create location
 */
export const getCreateLocationUrl = () => {
  return `/api/locations`;
};

export const createLocation = async (
  createLocationRequest: CreateLocationRequest,
  options?: RequestInit,
): Promise<Location> => {
  return customFetch<Location>(getCreateLocationUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createLocationRequest),
  });
};

export const getCreateLocationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLocation>>,
    TError,
    { data: BodyType<CreateLocationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLocation>>,
  TError,
  { data: BodyType<CreateLocationRequest> },
  TContext
> => {
  const mutationKey = ["createLocation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLocation>>,
    { data: BodyType<CreateLocationRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createLocation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLocationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createLocation>>
>;
export type CreateLocationMutationBody = BodyType<CreateLocationRequest>;
export type CreateLocationMutationError = ErrorType<unknown>;

/**
 * @summary Create location
 */
export const useCreateLocation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLocation>>,
    TError,
    { data: BodyType<CreateLocationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createLocation>>,
  TError,
  { data: BodyType<CreateLocationRequest> },
  TContext
> => {
  return useMutation(getCreateLocationMutationOptions(options));
};

/**
 * @summary Get location by ID
 */
export const getGetLocationUrl = (id: string) => {
  return `/api/locations/${id}`;
};

export const getLocation = async (
  id: string,
  options?: RequestInit,
): Promise<Location> => {
  return customFetch<Location>(getGetLocationUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetLocationQueryKey = (id: string) => {
  return [`/api/locations/${id}`] as const;
};

export const getGetLocationQueryOptions = <
  TData = Awaited<ReturnType<typeof getLocation>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLocation>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLocationQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocation>>> = ({
    signal,
  }) => getLocation(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLocation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLocationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLocation>>
>;
export type GetLocationQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get location by ID
 */

export function useGetLocation<
  TData = Awaited<ReturnType<typeof getLocation>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getLocation>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLocationQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update location
 */
export const getUpdateLocationUrl = (id: string) => {
  return `/api/locations/${id}`;
};

export const updateLocation = async (
  id: string,
  updateLocationRequest: UpdateLocationRequest,
  options?: RequestInit,
): Promise<Location> => {
  return customFetch<Location>(getUpdateLocationUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateLocationRequest),
  });
};

export const getUpdateLocationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLocation>>,
    TError,
    { id: string; data: BodyType<UpdateLocationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateLocation>>,
  TError,
  { id: string; data: BodyType<UpdateLocationRequest> },
  TContext
> => {
  const mutationKey = ["updateLocation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLocation>>,
    { id: string; data: BodyType<UpdateLocationRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateLocation(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateLocationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLocation>>
>;
export type UpdateLocationMutationBody = BodyType<UpdateLocationRequest>;
export type UpdateLocationMutationError = ErrorType<unknown>;

/**
 * @summary Update location
 */
export const useUpdateLocation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLocation>>,
    TError,
    { id: string; data: BodyType<UpdateLocationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateLocation>>,
  TError,
  { id: string; data: BodyType<UpdateLocationRequest> },
  TContext
> => {
  return useMutation(getUpdateLocationMutationOptions(options));
};

/**
 * @summary Soft-delete location
 */
export const getDeleteLocationUrl = (id: string) => {
  return `/api/locations/${id}`;
};

export const deleteLocation = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteLocationUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteLocationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLocation>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteLocation>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteLocation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteLocation>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteLocation(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteLocationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteLocation>>
>;

export type DeleteLocationMutationError = ErrorType<unknown>;

/**
 * @summary Soft-delete location
 */
export const useDeleteLocation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLocation>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteLocation>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteLocationMutationOptions(options));
};

/**
 * @summary List vehicle types
 */
export const getListVehicleTypesUrl = (params?: ListVehicleTypesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/vehicle-types?${stringifiedParams}`
    : `/api/vehicle-types`;
};

export const listVehicleTypes = async (
  params?: ListVehicleTypesParams,
  options?: RequestInit,
): Promise<VehicleTypeItemListResponse> => {
  return customFetch<VehicleTypeItemListResponse>(
    getListVehicleTypesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListVehicleTypesQueryKey = (
  params?: ListVehicleTypesParams,
) => {
  return [`/api/vehicle-types`, ...(params ? [params] : [])] as const;
};

export const getListVehicleTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof listVehicleTypes>>,
  TError = ErrorType<unknown>,
>(
  params?: ListVehicleTypesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVehicleTypes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListVehicleTypesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listVehicleTypes>>
  > = ({ signal }) => listVehicleTypes(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listVehicleTypes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListVehicleTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listVehicleTypes>>
>;
export type ListVehicleTypesQueryError = ErrorType<unknown>;

/**
 * @summary List vehicle types
 */

export function useListVehicleTypes<
  TData = Awaited<ReturnType<typeof listVehicleTypes>>,
  TError = ErrorType<unknown>,
>(
  params?: ListVehicleTypesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVehicleTypes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListVehicleTypesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create vehicle type
 */
export const getCreateVehicleTypeUrl = () => {
  return `/api/vehicle-types`;
};

export const createVehicleType = async (
  createVehicleTypeRequest: CreateVehicleTypeRequest,
  options?: RequestInit,
): Promise<VehicleTypeItem> => {
  return customFetch<VehicleTypeItem>(getCreateVehicleTypeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createVehicleTypeRequest),
  });
};

export const getCreateVehicleTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVehicleType>>,
    TError,
    { data: BodyType<CreateVehicleTypeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVehicleType>>,
  TError,
  { data: BodyType<CreateVehicleTypeRequest> },
  TContext
> => {
  const mutationKey = ["createVehicleType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createVehicleType>>,
    { data: BodyType<CreateVehicleTypeRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createVehicleType(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateVehicleTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createVehicleType>>
>;
export type CreateVehicleTypeMutationBody = BodyType<CreateVehicleTypeRequest>;
export type CreateVehicleTypeMutationError = ErrorType<unknown>;

/**
 * @summary Create vehicle type
 */
export const useCreateVehicleType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVehicleType>>,
    TError,
    { data: BodyType<CreateVehicleTypeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createVehicleType>>,
  TError,
  { data: BodyType<CreateVehicleTypeRequest> },
  TContext
> => {
  return useMutation(getCreateVehicleTypeMutationOptions(options));
};

/**
 * @summary Get vehicle type by ID
 */
export const getGetVehicleTypeUrl = (id: string) => {
  return `/api/vehicle-types/${id}`;
};

export const getVehicleType = async (
  id: string,
  options?: RequestInit,
): Promise<VehicleTypeItem> => {
  return customFetch<VehicleTypeItem>(getGetVehicleTypeUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetVehicleTypeQueryKey = (id: string) => {
  return [`/api/vehicle-types/${id}`] as const;
};

export const getGetVehicleTypeQueryOptions = <
  TData = Awaited<ReturnType<typeof getVehicleType>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVehicleType>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVehicleTypeQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVehicleType>>> = ({
    signal,
  }) => getVehicleType(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVehicleType>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVehicleTypeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVehicleType>>
>;
export type GetVehicleTypeQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get vehicle type by ID
 */

export function useGetVehicleType<
  TData = Awaited<ReturnType<typeof getVehicleType>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVehicleType>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVehicleTypeQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update vehicle type
 */
export const getUpdateVehicleTypeUrl = (id: string) => {
  return `/api/vehicle-types/${id}`;
};

export const updateVehicleType = async (
  id: string,
  updateVehicleTypeRequest: UpdateVehicleTypeRequest,
  options?: RequestInit,
): Promise<VehicleTypeItem> => {
  return customFetch<VehicleTypeItem>(getUpdateVehicleTypeUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateVehicleTypeRequest),
  });
};

export const getUpdateVehicleTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVehicleType>>,
    TError,
    { id: string; data: BodyType<UpdateVehicleTypeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVehicleType>>,
  TError,
  { id: string; data: BodyType<UpdateVehicleTypeRequest> },
  TContext
> => {
  const mutationKey = ["updateVehicleType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVehicleType>>,
    { id: string; data: BodyType<UpdateVehicleTypeRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateVehicleType(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVehicleTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateVehicleType>>
>;
export type UpdateVehicleTypeMutationBody = BodyType<UpdateVehicleTypeRequest>;
export type UpdateVehicleTypeMutationError = ErrorType<unknown>;

/**
 * @summary Update vehicle type
 */
export const useUpdateVehicleType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVehicleType>>,
    TError,
    { id: string; data: BodyType<UpdateVehicleTypeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateVehicleType>>,
  TError,
  { id: string; data: BodyType<UpdateVehicleTypeRequest> },
  TContext
> => {
  return useMutation(getUpdateVehicleTypeMutationOptions(options));
};

/**
 * @summary Soft-delete vehicle type
 */
export const getDeleteVehicleTypeUrl = (id: string) => {
  return `/api/vehicle-types/${id}`;
};

export const deleteVehicleType = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteVehicleTypeUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteVehicleTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVehicleType>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteVehicleType>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteVehicleType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteVehicleType>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteVehicleType(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteVehicleTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteVehicleType>>
>;

export type DeleteVehicleTypeMutationError = ErrorType<unknown>;

/**
 * @summary Soft-delete vehicle type
 */
export const useDeleteVehicleType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVehicleType>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteVehicleType>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteVehicleTypeMutationOptions(options));
};

/**
 * @summary List trailer types
 */
export const getListTrailerTypesUrl = (params?: ListTrailerTypesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/trailer-types?${stringifiedParams}`
    : `/api/trailer-types`;
};

export const listTrailerTypes = async (
  params?: ListTrailerTypesParams,
  options?: RequestInit,
): Promise<TrailerTypeItemListResponse> => {
  return customFetch<TrailerTypeItemListResponse>(
    getListTrailerTypesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListTrailerTypesQueryKey = (
  params?: ListTrailerTypesParams,
) => {
  return [`/api/trailer-types`, ...(params ? [params] : [])] as const;
};

export const getListTrailerTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof listTrailerTypes>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTrailerTypesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTrailerTypes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListTrailerTypesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTrailerTypes>>
  > = ({ signal }) => listTrailerTypes(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTrailerTypes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTrailerTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTrailerTypes>>
>;
export type ListTrailerTypesQueryError = ErrorType<unknown>;

/**
 * @summary List trailer types
 */

export function useListTrailerTypes<
  TData = Awaited<ReturnType<typeof listTrailerTypes>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTrailerTypesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTrailerTypes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTrailerTypesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create trailer type
 */
export const getCreateTrailerTypeUrl = () => {
  return `/api/trailer-types`;
};

export const createTrailerType = async (
  createTrailerTypeRequest: CreateTrailerTypeRequest,
  options?: RequestInit,
): Promise<TrailerTypeItem> => {
  return customFetch<TrailerTypeItem>(getCreateTrailerTypeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTrailerTypeRequest),
  });
};

export const getCreateTrailerTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTrailerType>>,
    TError,
    { data: BodyType<CreateTrailerTypeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTrailerType>>,
  TError,
  { data: BodyType<CreateTrailerTypeRequest> },
  TContext
> => {
  const mutationKey = ["createTrailerType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTrailerType>>,
    { data: BodyType<CreateTrailerTypeRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createTrailerType(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTrailerTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTrailerType>>
>;
export type CreateTrailerTypeMutationBody = BodyType<CreateTrailerTypeRequest>;
export type CreateTrailerTypeMutationError = ErrorType<unknown>;

/**
 * @summary Create trailer type
 */
export const useCreateTrailerType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTrailerType>>,
    TError,
    { data: BodyType<CreateTrailerTypeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTrailerType>>,
  TError,
  { data: BodyType<CreateTrailerTypeRequest> },
  TContext
> => {
  return useMutation(getCreateTrailerTypeMutationOptions(options));
};

/**
 * @summary Get trailer type by ID
 */
export const getGetTrailerTypeUrl = (id: string) => {
  return `/api/trailer-types/${id}`;
};

export const getTrailerType = async (
  id: string,
  options?: RequestInit,
): Promise<TrailerTypeItem> => {
  return customFetch<TrailerTypeItem>(getGetTrailerTypeUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetTrailerTypeQueryKey = (id: string) => {
  return [`/api/trailer-types/${id}`] as const;
};

export const getGetTrailerTypeQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrailerType>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrailerType>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTrailerTypeQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrailerType>>> = ({
    signal,
  }) => getTrailerType(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrailerType>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTrailerTypeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrailerType>>
>;
export type GetTrailerTypeQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get trailer type by ID
 */

export function useGetTrailerType<
  TData = Awaited<ReturnType<typeof getTrailerType>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrailerType>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTrailerTypeQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update trailer type
 */
export const getUpdateTrailerTypeUrl = (id: string) => {
  return `/api/trailer-types/${id}`;
};

export const updateTrailerType = async (
  id: string,
  updateTrailerTypeRequest: UpdateTrailerTypeRequest,
  options?: RequestInit,
): Promise<TrailerTypeItem> => {
  return customFetch<TrailerTypeItem>(getUpdateTrailerTypeUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTrailerTypeRequest),
  });
};

export const getUpdateTrailerTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTrailerType>>,
    TError,
    { id: string; data: BodyType<UpdateTrailerTypeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTrailerType>>,
  TError,
  { id: string; data: BodyType<UpdateTrailerTypeRequest> },
  TContext
> => {
  const mutationKey = ["updateTrailerType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTrailerType>>,
    { id: string; data: BodyType<UpdateTrailerTypeRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTrailerType(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTrailerTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTrailerType>>
>;
export type UpdateTrailerTypeMutationBody = BodyType<UpdateTrailerTypeRequest>;
export type UpdateTrailerTypeMutationError = ErrorType<unknown>;

/**
 * @summary Update trailer type
 */
export const useUpdateTrailerType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTrailerType>>,
    TError,
    { id: string; data: BodyType<UpdateTrailerTypeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTrailerType>>,
  TError,
  { id: string; data: BodyType<UpdateTrailerTypeRequest> },
  TContext
> => {
  return useMutation(getUpdateTrailerTypeMutationOptions(options));
};

/**
 * @summary Soft-delete trailer type
 */
export const getDeleteTrailerTypeUrl = (id: string) => {
  return `/api/trailer-types/${id}`;
};

export const deleteTrailerType = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteTrailerTypeUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTrailerTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTrailerType>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTrailerType>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteTrailerType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTrailerType>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTrailerType(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTrailerTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTrailerType>>
>;

export type DeleteTrailerTypeMutationError = ErrorType<unknown>;

/**
 * @summary Soft-delete trailer type
 */
export const useDeleteTrailerType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTrailerType>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTrailerType>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteTrailerTypeMutationOptions(options));
};

/**
 * @summary List vehicles
 */
export const getListVehiclesUrl = (params?: ListVehiclesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/vehicles?${stringifiedParams}`
    : `/api/vehicles`;
};

export const listVehicles = async (
  params?: ListVehiclesParams,
  options?: RequestInit,
): Promise<VehicleListResponse> => {
  return customFetch<VehicleListResponse>(getListVehiclesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListVehiclesQueryKey = (params?: ListVehiclesParams) => {
  return [`/api/vehicles`, ...(params ? [params] : [])] as const;
};

export const getListVehiclesQueryOptions = <
  TData = Awaited<ReturnType<typeof listVehicles>>,
  TError = ErrorType<unknown>,
>(
  params?: ListVehiclesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVehicles>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListVehiclesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listVehicles>>> = ({
    signal,
  }) => listVehicles(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listVehicles>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListVehiclesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listVehicles>>
>;
export type ListVehiclesQueryError = ErrorType<unknown>;

/**
 * @summary List vehicles
 */

export function useListVehicles<
  TData = Awaited<ReturnType<typeof listVehicles>>,
  TError = ErrorType<unknown>,
>(
  params?: ListVehiclesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVehicles>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListVehiclesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create vehicle
 */
export const getCreateVehicleUrl = () => {
  return `/api/vehicles`;
};

export const createVehicle = async (
  createVehicleRequest: CreateVehicleRequest,
  options?: RequestInit,
): Promise<Vehicle> => {
  return customFetch<Vehicle>(getCreateVehicleUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createVehicleRequest),
  });
};

export const getCreateVehicleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVehicle>>,
    TError,
    { data: BodyType<CreateVehicleRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVehicle>>,
  TError,
  { data: BodyType<CreateVehicleRequest> },
  TContext
> => {
  const mutationKey = ["createVehicle"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createVehicle>>,
    { data: BodyType<CreateVehicleRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createVehicle(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateVehicleMutationResult = NonNullable<
  Awaited<ReturnType<typeof createVehicle>>
>;
export type CreateVehicleMutationBody = BodyType<CreateVehicleRequest>;
export type CreateVehicleMutationError = ErrorType<unknown>;

/**
 * @summary Create vehicle
 */
export const useCreateVehicle = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVehicle>>,
    TError,
    { data: BodyType<CreateVehicleRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createVehicle>>,
  TError,
  { data: BodyType<CreateVehicleRequest> },
  TContext
> => {
  return useMutation(getCreateVehicleMutationOptions(options));
};

/**
 * @summary Get vehicle by ID
 */
export const getGetVehicleUrl = (id: string) => {
  return `/api/vehicles/${id}`;
};

export const getVehicle = async (
  id: string,
  options?: RequestInit,
): Promise<Vehicle> => {
  return customFetch<Vehicle>(getGetVehicleUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetVehicleQueryKey = (id: string) => {
  return [`/api/vehicles/${id}`] as const;
};

export const getGetVehicleQueryOptions = <
  TData = Awaited<ReturnType<typeof getVehicle>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVehicle>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVehicleQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVehicle>>> = ({
    signal,
  }) => getVehicle(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVehicle>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVehicleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVehicle>>
>;
export type GetVehicleQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get vehicle by ID
 */

export function useGetVehicle<
  TData = Awaited<ReturnType<typeof getVehicle>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVehicle>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVehicleQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update vehicle
 */
export const getUpdateVehicleUrl = (id: string) => {
  return `/api/vehicles/${id}`;
};

export const updateVehicle = async (
  id: string,
  updateVehicleRequest: UpdateVehicleRequest,
  options?: RequestInit,
): Promise<Vehicle> => {
  return customFetch<Vehicle>(getUpdateVehicleUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateVehicleRequest),
  });
};

export const getUpdateVehicleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVehicle>>,
    TError,
    { id: string; data: BodyType<UpdateVehicleRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVehicle>>,
  TError,
  { id: string; data: BodyType<UpdateVehicleRequest> },
  TContext
> => {
  const mutationKey = ["updateVehicle"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVehicle>>,
    { id: string; data: BodyType<UpdateVehicleRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateVehicle(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVehicleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateVehicle>>
>;
export type UpdateVehicleMutationBody = BodyType<UpdateVehicleRequest>;
export type UpdateVehicleMutationError = ErrorType<unknown>;

/**
 * @summary Update vehicle
 */
export const useUpdateVehicle = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVehicle>>,
    TError,
    { id: string; data: BodyType<UpdateVehicleRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateVehicle>>,
  TError,
  { id: string; data: BodyType<UpdateVehicleRequest> },
  TContext
> => {
  return useMutation(getUpdateVehicleMutationOptions(options));
};

/**
 * @summary Soft-delete vehicle
 */
export const getDeleteVehicleUrl = (id: string) => {
  return `/api/vehicles/${id}`;
};

export const deleteVehicle = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteVehicleUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteVehicleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVehicle>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteVehicle>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteVehicle"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteVehicle>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteVehicle(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteVehicleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteVehicle>>
>;

export type DeleteVehicleMutationError = ErrorType<unknown>;

/**
 * @summary Soft-delete vehicle
 */
export const useDeleteVehicle = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVehicle>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteVehicle>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteVehicleMutationOptions(options));
};

/**
 * @summary List trailers
 */
export const getListTrailersUrl = (params?: ListTrailersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/trailers?${stringifiedParams}`
    : `/api/trailers`;
};

export const listTrailers = async (
  params?: ListTrailersParams,
  options?: RequestInit,
): Promise<TrailerListResponse> => {
  return customFetch<TrailerListResponse>(getListTrailersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListTrailersQueryKey = (params?: ListTrailersParams) => {
  return [`/api/trailers`, ...(params ? [params] : [])] as const;
};

export const getListTrailersQueryOptions = <
  TData = Awaited<ReturnType<typeof listTrailers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTrailersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTrailers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTrailersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTrailers>>> = ({
    signal,
  }) => listTrailers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTrailers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTrailersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTrailers>>
>;
export type ListTrailersQueryError = ErrorType<unknown>;

/**
 * @summary List trailers
 */

export function useListTrailers<
  TData = Awaited<ReturnType<typeof listTrailers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTrailersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTrailers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTrailersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create trailer
 */
export const getCreateTrailerUrl = () => {
  return `/api/trailers`;
};

export const createTrailer = async (
  createTrailerRequest: CreateTrailerRequest,
  options?: RequestInit,
): Promise<Trailer> => {
  return customFetch<Trailer>(getCreateTrailerUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTrailerRequest),
  });
};

export const getCreateTrailerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTrailer>>,
    TError,
    { data: BodyType<CreateTrailerRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTrailer>>,
  TError,
  { data: BodyType<CreateTrailerRequest> },
  TContext
> => {
  const mutationKey = ["createTrailer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTrailer>>,
    { data: BodyType<CreateTrailerRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createTrailer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTrailerMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTrailer>>
>;
export type CreateTrailerMutationBody = BodyType<CreateTrailerRequest>;
export type CreateTrailerMutationError = ErrorType<unknown>;

/**
 * @summary Create trailer
 */
export const useCreateTrailer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTrailer>>,
    TError,
    { data: BodyType<CreateTrailerRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTrailer>>,
  TError,
  { data: BodyType<CreateTrailerRequest> },
  TContext
> => {
  return useMutation(getCreateTrailerMutationOptions(options));
};

/**
 * @summary Get trailer by ID
 */
export const getGetTrailerUrl = (id: string) => {
  return `/api/trailers/${id}`;
};

export const getTrailer = async (
  id: string,
  options?: RequestInit,
): Promise<Trailer> => {
  return customFetch<Trailer>(getGetTrailerUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetTrailerQueryKey = (id: string) => {
  return [`/api/trailers/${id}`] as const;
};

export const getGetTrailerQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrailer>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrailer>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTrailerQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrailer>>> = ({
    signal,
  }) => getTrailer(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrailer>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTrailerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrailer>>
>;
export type GetTrailerQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get trailer by ID
 */

export function useGetTrailer<
  TData = Awaited<ReturnType<typeof getTrailer>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrailer>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTrailerQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update trailer
 */
export const getUpdateTrailerUrl = (id: string) => {
  return `/api/trailers/${id}`;
};

export const updateTrailer = async (
  id: string,
  updateTrailerRequest: UpdateTrailerRequest,
  options?: RequestInit,
): Promise<Trailer> => {
  return customFetch<Trailer>(getUpdateTrailerUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTrailerRequest),
  });
};

export const getUpdateTrailerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTrailer>>,
    TError,
    { id: string; data: BodyType<UpdateTrailerRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTrailer>>,
  TError,
  { id: string; data: BodyType<UpdateTrailerRequest> },
  TContext
> => {
  const mutationKey = ["updateTrailer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTrailer>>,
    { id: string; data: BodyType<UpdateTrailerRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTrailer(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTrailerMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTrailer>>
>;
export type UpdateTrailerMutationBody = BodyType<UpdateTrailerRequest>;
export type UpdateTrailerMutationError = ErrorType<unknown>;

/**
 * @summary Update trailer
 */
export const useUpdateTrailer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTrailer>>,
    TError,
    { id: string; data: BodyType<UpdateTrailerRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTrailer>>,
  TError,
  { id: string; data: BodyType<UpdateTrailerRequest> },
  TContext
> => {
  return useMutation(getUpdateTrailerMutationOptions(options));
};

/**
 * @summary Soft-delete trailer
 */
export const getDeleteTrailerUrl = (id: string) => {
  return `/api/trailers/${id}`;
};

export const deleteTrailer = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteTrailerUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTrailerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTrailer>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTrailer>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteTrailer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTrailer>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTrailer(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTrailerMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTrailer>>
>;

export type DeleteTrailerMutationError = ErrorType<unknown>;

/**
 * @summary Soft-delete trailer
 */
export const useDeleteTrailer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTrailer>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTrailer>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteTrailerMutationOptions(options));
};

/**
 * @summary List personnel
 */
export const getListPersonnelUrl = (params?: ListPersonnelParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/personnel?${stringifiedParams}`
    : `/api/personnel`;
};

export const listPersonnel = async (
  params?: ListPersonnelParams,
  options?: RequestInit,
): Promise<PersonnelListResponse> => {
  return customFetch<PersonnelListResponse>(getListPersonnelUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListPersonnelQueryKey = (params?: ListPersonnelParams) => {
  return [`/api/personnel`, ...(params ? [params] : [])] as const;
};

export const getListPersonnelQueryOptions = <
  TData = Awaited<ReturnType<typeof listPersonnel>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPersonnelParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPersonnel>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPersonnelQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPersonnel>>> = ({
    signal,
  }) => listPersonnel(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPersonnel>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPersonnelQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPersonnel>>
>;
export type ListPersonnelQueryError = ErrorType<unknown>;

/**
 * @summary List personnel
 */

export function useListPersonnel<
  TData = Awaited<ReturnType<typeof listPersonnel>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPersonnelParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPersonnel>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPersonnelQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create personnel
 */
export const getCreatePersonnelUrl = () => {
  return `/api/personnel`;
};

export const createPersonnel = async (
  createPersonnelRequest: CreatePersonnelRequest,
  options?: RequestInit,
): Promise<PersonnelItem> => {
  return customFetch<PersonnelItem>(getCreatePersonnelUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createPersonnelRequest),
  });
};

export const getCreatePersonnelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPersonnel>>,
    TError,
    { data: BodyType<CreatePersonnelRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPersonnel>>,
  TError,
  { data: BodyType<CreatePersonnelRequest> },
  TContext
> => {
  const mutationKey = ["createPersonnel"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPersonnel>>,
    { data: BodyType<CreatePersonnelRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createPersonnel(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePersonnelMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPersonnel>>
>;
export type CreatePersonnelMutationBody = BodyType<CreatePersonnelRequest>;
export type CreatePersonnelMutationError = ErrorType<unknown>;

/**
 * @summary Create personnel
 */
export const useCreatePersonnel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPersonnel>>,
    TError,
    { data: BodyType<CreatePersonnelRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPersonnel>>,
  TError,
  { data: BodyType<CreatePersonnelRequest> },
  TContext
> => {
  return useMutation(getCreatePersonnelMutationOptions(options));
};

/**
 * @summary Get personnel by ID
 */
export const getGetPersonnelUrl = (id: string) => {
  return `/api/personnel/${id}`;
};

export const getPersonnel = async (
  id: string,
  options?: RequestInit,
): Promise<PersonnelItem> => {
  return customFetch<PersonnelItem>(getGetPersonnelUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetPersonnelQueryKey = (id: string) => {
  return [`/api/personnel/${id}`] as const;
};

export const getGetPersonnelQueryOptions = <
  TData = Awaited<ReturnType<typeof getPersonnel>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPersonnel>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPersonnelQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonnel>>> = ({
    signal,
  }) => getPersonnel(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPersonnel>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPersonnelQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPersonnel>>
>;
export type GetPersonnelQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get personnel by ID
 */

export function useGetPersonnel<
  TData = Awaited<ReturnType<typeof getPersonnel>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPersonnel>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPersonnelQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update personnel
 */
export const getUpdatePersonnelUrl = (id: string) => {
  return `/api/personnel/${id}`;
};

export const updatePersonnel = async (
  id: string,
  updatePersonnelRequest: UpdatePersonnelRequest,
  options?: RequestInit,
): Promise<PersonnelItem> => {
  return customFetch<PersonnelItem>(getUpdatePersonnelUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updatePersonnelRequest),
  });
};

export const getUpdatePersonnelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePersonnel>>,
    TError,
    { id: string; data: BodyType<UpdatePersonnelRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePersonnel>>,
  TError,
  { id: string; data: BodyType<UpdatePersonnelRequest> },
  TContext
> => {
  const mutationKey = ["updatePersonnel"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePersonnel>>,
    { id: string; data: BodyType<UpdatePersonnelRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updatePersonnel(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePersonnelMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePersonnel>>
>;
export type UpdatePersonnelMutationBody = BodyType<UpdatePersonnelRequest>;
export type UpdatePersonnelMutationError = ErrorType<unknown>;

/**
 * @summary Update personnel
 */
export const useUpdatePersonnel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePersonnel>>,
    TError,
    { id: string; data: BodyType<UpdatePersonnelRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePersonnel>>,
  TError,
  { id: string; data: BodyType<UpdatePersonnelRequest> },
  TContext
> => {
  return useMutation(getUpdatePersonnelMutationOptions(options));
};

/**
 * @summary Soft-delete personnel (sets estado=inactivo)
 */
export const getDeletePersonnelUrl = (id: string) => {
  return `/api/personnel/${id}`;
};

export const deletePersonnel = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeletePersonnelUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeletePersonnelMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePersonnel>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePersonnel>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deletePersonnel"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePersonnel>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deletePersonnel(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePersonnelMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePersonnel>>
>;

export type DeletePersonnelMutationError = ErrorType<unknown>;

/**
 * @summary Soft-delete personnel (sets estado=inactivo)
 */
export const useDeletePersonnel = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePersonnel>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePersonnel>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeletePersonnelMutationOptions(options));
};

/**
 * @summary List service types
 */
export const getListServiceTypesUrl = (params?: ListServiceTypesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/service-types?${stringifiedParams}`
    : `/api/service-types`;
};

export const listServiceTypes = async (
  params?: ListServiceTypesParams,
  options?: RequestInit,
): Promise<ServiceTypeListResponse> => {
  return customFetch<ServiceTypeListResponse>(getListServiceTypesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListServiceTypesQueryKey = (
  params?: ListServiceTypesParams,
) => {
  return [`/api/service-types`, ...(params ? [params] : [])] as const;
};

export const getListServiceTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof listServiceTypes>>,
  TError = ErrorType<unknown>,
>(
  params?: ListServiceTypesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listServiceTypes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListServiceTypesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listServiceTypes>>
  > = ({ signal }) => listServiceTypes(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listServiceTypes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListServiceTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listServiceTypes>>
>;
export type ListServiceTypesQueryError = ErrorType<unknown>;

/**
 * @summary List service types
 */

export function useListServiceTypes<
  TData = Awaited<ReturnType<typeof listServiceTypes>>,
  TError = ErrorType<unknown>,
>(
  params?: ListServiceTypesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listServiceTypes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListServiceTypesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create service type
 */
export const getCreateServiceTypeUrl = () => {
  return `/api/service-types`;
};

export const createServiceType = async (
  createServiceTypeRequest: CreateServiceTypeRequest,
  options?: RequestInit,
): Promise<ServiceType> => {
  return customFetch<ServiceType>(getCreateServiceTypeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createServiceTypeRequest),
  });
};

export const getCreateServiceTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createServiceType>>,
    TError,
    { data: BodyType<CreateServiceTypeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createServiceType>>,
  TError,
  { data: BodyType<CreateServiceTypeRequest> },
  TContext
> => {
  const mutationKey = ["createServiceType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createServiceType>>,
    { data: BodyType<CreateServiceTypeRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createServiceType(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateServiceTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createServiceType>>
>;
export type CreateServiceTypeMutationBody = BodyType<CreateServiceTypeRequest>;
export type CreateServiceTypeMutationError = ErrorType<unknown>;

/**
 * @summary Create service type
 */
export const useCreateServiceType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createServiceType>>,
    TError,
    { data: BodyType<CreateServiceTypeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createServiceType>>,
  TError,
  { data: BodyType<CreateServiceTypeRequest> },
  TContext
> => {
  return useMutation(getCreateServiceTypeMutationOptions(options));
};

/**
 * @summary Get service type by ID
 */
export const getGetServiceTypeUrl = (id: string) => {
  return `/api/service-types/${id}`;
};

export const getServiceType = async (
  id: string,
  options?: RequestInit,
): Promise<ServiceType> => {
  return customFetch<ServiceType>(getGetServiceTypeUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetServiceTypeQueryKey = (id: string) => {
  return [`/api/service-types/${id}`] as const;
};

export const getGetServiceTypeQueryOptions = <
  TData = Awaited<ReturnType<typeof getServiceType>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getServiceType>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetServiceTypeQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceType>>> = ({
    signal,
  }) => getServiceType(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getServiceType>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetServiceTypeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getServiceType>>
>;
export type GetServiceTypeQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get service type by ID
 */

export function useGetServiceType<
  TData = Awaited<ReturnType<typeof getServiceType>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getServiceType>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetServiceTypeQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update service type
 */
export const getUpdateServiceTypeUrl = (id: string) => {
  return `/api/service-types/${id}`;
};

export const updateServiceType = async (
  id: string,
  updateServiceTypeRequest: UpdateServiceTypeRequest,
  options?: RequestInit,
): Promise<ServiceType> => {
  return customFetch<ServiceType>(getUpdateServiceTypeUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateServiceTypeRequest),
  });
};

export const getUpdateServiceTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateServiceType>>,
    TError,
    { id: string; data: BodyType<UpdateServiceTypeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateServiceType>>,
  TError,
  { id: string; data: BodyType<UpdateServiceTypeRequest> },
  TContext
> => {
  const mutationKey = ["updateServiceType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateServiceType>>,
    { id: string; data: BodyType<UpdateServiceTypeRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateServiceType(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateServiceTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateServiceType>>
>;
export type UpdateServiceTypeMutationBody = BodyType<UpdateServiceTypeRequest>;
export type UpdateServiceTypeMutationError = ErrorType<unknown>;

/**
 * @summary Update service type
 */
export const useUpdateServiceType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateServiceType>>,
    TError,
    { id: string; data: BodyType<UpdateServiceTypeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateServiceType>>,
  TError,
  { id: string; data: BodyType<UpdateServiceTypeRequest> },
  TContext
> => {
  return useMutation(getUpdateServiceTypeMutationOptions(options));
};

/**
 * @summary Soft-delete service type
 */
export const getDeleteServiceTypeUrl = (id: string) => {
  return `/api/service-types/${id}`;
};

export const deleteServiceType = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteServiceTypeUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteServiceTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteServiceType>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteServiceType>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteServiceType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteServiceType>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteServiceType(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteServiceTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteServiceType>>
>;

export type DeleteServiceTypeMutationError = ErrorType<unknown>;

/**
 * @summary Soft-delete service type
 */
export const useDeleteServiceType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteServiceType>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteServiceType>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteServiceTypeMutationOptions(options));
};

/**
 * @summary List waste types
 */
export const getListWasteTypesUrl = (params?: ListWasteTypesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/waste-types?${stringifiedParams}`
    : `/api/waste-types`;
};

export const listWasteTypes = async (
  params?: ListWasteTypesParams,
  options?: RequestInit,
): Promise<WasteTypeListResponse> => {
  return customFetch<WasteTypeListResponse>(getListWasteTypesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListWasteTypesQueryKey = (params?: ListWasteTypesParams) => {
  return [`/api/waste-types`, ...(params ? [params] : [])] as const;
};

export const getListWasteTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof listWasteTypes>>,
  TError = ErrorType<unknown>,
>(
  params?: ListWasteTypesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWasteTypes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListWasteTypesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listWasteTypes>>> = ({
    signal,
  }) => listWasteTypes(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listWasteTypes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListWasteTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWasteTypes>>
>;
export type ListWasteTypesQueryError = ErrorType<unknown>;

/**
 * @summary List waste types
 */

export function useListWasteTypes<
  TData = Awaited<ReturnType<typeof listWasteTypes>>,
  TError = ErrorType<unknown>,
>(
  params?: ListWasteTypesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWasteTypes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListWasteTypesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create waste type
 */
export const getCreateWasteTypeUrl = () => {
  return `/api/waste-types`;
};

export const createWasteType = async (
  createWasteTypeRequest: CreateWasteTypeRequest,
  options?: RequestInit,
): Promise<WasteType> => {
  return customFetch<WasteType>(getCreateWasteTypeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createWasteTypeRequest),
  });
};

export const getCreateWasteTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWasteType>>,
    TError,
    { data: BodyType<CreateWasteTypeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createWasteType>>,
  TError,
  { data: BodyType<CreateWasteTypeRequest> },
  TContext
> => {
  const mutationKey = ["createWasteType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWasteType>>,
    { data: BodyType<CreateWasteTypeRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createWasteType(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateWasteTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWasteType>>
>;
export type CreateWasteTypeMutationBody = BodyType<CreateWasteTypeRequest>;
export type CreateWasteTypeMutationError = ErrorType<unknown>;

/**
 * @summary Create waste type
 */
export const useCreateWasteType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWasteType>>,
    TError,
    { data: BodyType<CreateWasteTypeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createWasteType>>,
  TError,
  { data: BodyType<CreateWasteTypeRequest> },
  TContext
> => {
  return useMutation(getCreateWasteTypeMutationOptions(options));
};

/**
 * @summary Get waste type by ID
 */
export const getGetWasteTypeUrl = (id: string) => {
  return `/api/waste-types/${id}`;
};

export const getWasteType = async (
  id: string,
  options?: RequestInit,
): Promise<WasteType> => {
  return customFetch<WasteType>(getGetWasteTypeUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetWasteTypeQueryKey = (id: string) => {
  return [`/api/waste-types/${id}`] as const;
};

export const getGetWasteTypeQueryOptions = <
  TData = Awaited<ReturnType<typeof getWasteType>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWasteType>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWasteTypeQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWasteType>>> = ({
    signal,
  }) => getWasteType(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWasteType>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWasteTypeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWasteType>>
>;
export type GetWasteTypeQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get waste type by ID
 */

export function useGetWasteType<
  TData = Awaited<ReturnType<typeof getWasteType>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWasteType>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWasteTypeQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update waste type
 */
export const getUpdateWasteTypeUrl = (id: string) => {
  return `/api/waste-types/${id}`;
};

export const updateWasteType = async (
  id: string,
  updateWasteTypeRequest: UpdateWasteTypeRequest,
  options?: RequestInit,
): Promise<WasteType> => {
  return customFetch<WasteType>(getUpdateWasteTypeUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateWasteTypeRequest),
  });
};

export const getUpdateWasteTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWasteType>>,
    TError,
    { id: string; data: BodyType<UpdateWasteTypeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWasteType>>,
  TError,
  { id: string; data: BodyType<UpdateWasteTypeRequest> },
  TContext
> => {
  const mutationKey = ["updateWasteType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWasteType>>,
    { id: string; data: BodyType<UpdateWasteTypeRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateWasteType(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWasteTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateWasteType>>
>;
export type UpdateWasteTypeMutationBody = BodyType<UpdateWasteTypeRequest>;
export type UpdateWasteTypeMutationError = ErrorType<unknown>;

/**
 * @summary Update waste type
 */
export const useUpdateWasteType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWasteType>>,
    TError,
    { id: string; data: BodyType<UpdateWasteTypeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateWasteType>>,
  TError,
  { id: string; data: BodyType<UpdateWasteTypeRequest> },
  TContext
> => {
  return useMutation(getUpdateWasteTypeMutationOptions(options));
};

/**
 * @summary Soft-delete waste type
 */
export const getDeleteWasteTypeUrl = (id: string) => {
  return `/api/waste-types/${id}`;
};

export const deleteWasteType = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteWasteTypeUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteWasteTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWasteType>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteWasteType>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteWasteType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteWasteType>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteWasteType(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteWasteTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteWasteType>>
>;

export type DeleteWasteTypeMutationError = ErrorType<unknown>;

/**
 * @summary Soft-delete waste type
 */
export const useDeleteWasteType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWasteType>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteWasteType>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteWasteTypeMutationOptions(options));
};

/**
 * @summary List services
 */
export const getListServicesUrl = (params?: ListServicesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/services?${stringifiedParams}`
    : `/api/services`;
};

export const listServices = async (
  params?: ListServicesParams,
  options?: RequestInit,
): Promise<ServiceListResponse> => {
  return customFetch<ServiceListResponse>(getListServicesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListServicesQueryKey = (params?: ListServicesParams) => {
  return [`/api/services`, ...(params ? [params] : [])] as const;
};

export const getListServicesQueryOptions = <
  TData = Awaited<ReturnType<typeof listServices>>,
  TError = ErrorType<unknown>,
>(
  params?: ListServicesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listServices>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListServicesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listServices>>> = ({
    signal,
  }) => listServices(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listServices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListServicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listServices>>
>;
export type ListServicesQueryError = ErrorType<unknown>;

/**
 * @summary List services
 */

export function useListServices<
  TData = Awaited<ReturnType<typeof listServices>>,
  TError = ErrorType<unknown>,
>(
  params?: ListServicesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listServices>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListServicesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create service
 */
export const getCreateServiceUrl = () => {
  return `/api/services`;
};

export const createService = async (
  createServiceRequest: CreateServiceRequest,
  options?: RequestInit,
): Promise<ServiceDetail> => {
  return customFetch<ServiceDetail>(getCreateServiceUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createServiceRequest),
  });
};

export const getCreateServiceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createService>>,
    TError,
    { data: BodyType<CreateServiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createService>>,
  TError,
  { data: BodyType<CreateServiceRequest> },
  TContext
> => {
  const mutationKey = ["createService"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createService>>,
    { data: BodyType<CreateServiceRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createService(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateServiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createService>>
>;
export type CreateServiceMutationBody = BodyType<CreateServiceRequest>;
export type CreateServiceMutationError = ErrorType<unknown>;

/**
 * @summary Create service
 */
export const useCreateService = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createService>>,
    TError,
    { data: BodyType<CreateServiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createService>>,
  TError,
  { data: BodyType<CreateServiceRequest> },
  TContext
> => {
  return useMutation(getCreateServiceMutationOptions(options));
};

/**
 * @summary Get service by ID
 */
export const getGetServiceUrl = (id: string) => {
  return `/api/services/${id}`;
};

export const getService = async (
  id: string,
  options?: RequestInit,
): Promise<ServiceDetail> => {
  return customFetch<ServiceDetail>(getGetServiceUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetServiceQueryKey = (id: string) => {
  return [`/api/services/${id}`] as const;
};

export const getGetServiceQueryOptions = <
  TData = Awaited<ReturnType<typeof getService>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getService>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetServiceQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getService>>> = ({
    signal,
  }) => getService(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getService>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetServiceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getService>>
>;
export type GetServiceQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get service by ID
 */

export function useGetService<
  TData = Awaited<ReturnType<typeof getService>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getService>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetServiceQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update service (logistics edit)
 */
export const getUpdateServiceUrl = (id: string) => {
  return `/api/services/${id}`;
};

export const updateService = async (
  id: string,
  updateServiceRequest: UpdateServiceRequest,
  options?: RequestInit,
): Promise<ServiceDetail> => {
  return customFetch<ServiceDetail>(getUpdateServiceUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateServiceRequest),
  });
};

export const getUpdateServiceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateService>>,
    TError,
    { id: string; data: BodyType<UpdateServiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateService>>,
  TError,
  { id: string; data: BodyType<UpdateServiceRequest> },
  TContext
> => {
  const mutationKey = ["updateService"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateService>>,
    { id: string; data: BodyType<UpdateServiceRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateService(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateServiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateService>>
>;
export type UpdateServiceMutationBody = BodyType<UpdateServiceRequest>;
export type UpdateServiceMutationError = ErrorType<unknown>;

/**
 * @summary Update service (logistics edit)
 */
export const useUpdateService = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateService>>,
    TError,
    { id: string; data: BodyType<UpdateServiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateService>>,
  TError,
  { id: string; data: BodyType<UpdateServiceRequest> },
  TContext
> => {
  return useMutation(getUpdateServiceMutationOptions(options));
};

/**
 * @summary Cancel service (sets estado=cancelado)
 */
export const getDeleteServiceUrl = (id: string) => {
  return `/api/services/${id}`;
};

export const deleteService = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteServiceUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteServiceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteService>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteService>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteService"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteService>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteService(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteServiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteService>>
>;

export type DeleteServiceMutationError = ErrorType<unknown>;

/**
 * @summary Cancel service (sets estado=cancelado)
 */
export const useDeleteService = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteService>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteService>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteServiceMutationOptions(options));
};

/**
 * @summary Assign vehicle and driver to service
 */
export const getAssignServiceUrl = (id: string) => {
  return `/api/services/${id}/assign`;
};

export const assignService = async (
  id: string,
  assignServiceRequest: AssignServiceRequest,
  options?: RequestInit,
): Promise<ServiceDetail> => {
  return customFetch<ServiceDetail>(getAssignServiceUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(assignServiceRequest),
  });
};

export const getAssignServiceMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignService>>,
    TError,
    { id: string; data: BodyType<AssignServiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignService>>,
  TError,
  { id: string; data: BodyType<AssignServiceRequest> },
  TContext
> => {
  const mutationKey = ["assignService"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignService>>,
    { id: string; data: BodyType<AssignServiceRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return assignService(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignServiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignService>>
>;
export type AssignServiceMutationBody = BodyType<AssignServiceRequest>;
export type AssignServiceMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Assign vehicle and driver to service
 */
export const useAssignService = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignService>>,
    TError,
    { id: string; data: BodyType<AssignServiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof assignService>>,
  TError,
  { id: string; data: BodyType<AssignServiceRequest> },
  TContext
> => {
  return useMutation(getAssignServiceMutationOptions(options));
};

/**
 * @summary Send service to driver
 */
export const getSendServiceToDriverUrl = (id: string) => {
  return `/api/services/${id}/send`;
};

export const sendServiceToDriver = async (
  id: string,
  options?: RequestInit,
): Promise<ServiceDetail> => {
  return customFetch<ServiceDetail>(getSendServiceToDriverUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getSendServiceToDriverMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendServiceToDriver>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendServiceToDriver>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["sendServiceToDriver"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendServiceToDriver>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return sendServiceToDriver(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendServiceToDriverMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendServiceToDriver>>
>;

export type SendServiceToDriverMutationError = ErrorType<unknown>;

/**
 * @summary Send service to driver
 */
export const useSendServiceToDriver = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendServiceToDriver>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendServiceToDriver>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getSendServiceToDriverMutationOptions(options));
};

/**
 * @summary Driver registers arrival (starts service)
 */
export const getRegisterArrivalUrl = (id: string) => {
  return `/api/services/${id}/arrive`;
};

export const registerArrival = async (
  id: string,
  arrivalRequest?: ArrivalRequest,
  options?: RequestInit,
): Promise<ServiceDetail> => {
  return customFetch<ServiceDetail>(getRegisterArrivalUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(arrivalRequest),
  });
};

export const getRegisterArrivalMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerArrival>>,
    TError,
    { id: string; data: BodyType<ArrivalRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerArrival>>,
  TError,
  { id: string; data: BodyType<ArrivalRequest> },
  TContext
> => {
  const mutationKey = ["registerArrival"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerArrival>>,
    { id: string; data: BodyType<ArrivalRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return registerArrival(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterArrivalMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerArrival>>
>;
export type RegisterArrivalMutationBody = BodyType<ArrivalRequest>;
export type RegisterArrivalMutationError = ErrorType<unknown>;

/**
 * @summary Driver registers arrival (starts service)
 */
export const useRegisterArrival = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerArrival>>,
    TError,
    { id: string; data: BodyType<ArrivalRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof registerArrival>>,
  TError,
  { id: string; data: BodyType<ArrivalRequest> },
  TContext
> => {
  return useMutation(getRegisterArrivalMutationOptions(options));
};

/**
 * @summary Driver completes service
 */
export const getCompleteServiceUrl = (id: string) => {
  return `/api/services/${id}/complete`;
};

export const completeService = async (
  id: string,
  completeServiceRequest: CompleteServiceRequest,
  options?: RequestInit,
): Promise<ServiceDetail> => {
  return customFetch<ServiceDetail>(getCompleteServiceUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(completeServiceRequest),
  });
};

export const getCompleteServiceMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeService>>,
    TError,
    { id: string; data: BodyType<CompleteServiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeService>>,
  TError,
  { id: string; data: BodyType<CompleteServiceRequest> },
  TContext
> => {
  const mutationKey = ["completeService"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeService>>,
    { id: string; data: BodyType<CompleteServiceRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return completeService(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteServiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeService>>
>;
export type CompleteServiceMutationBody = BodyType<CompleteServiceRequest>;
export type CompleteServiceMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Driver completes service
 */
export const useCompleteService = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeService>>,
    TError,
    { id: string; data: BodyType<CompleteServiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof completeService>>,
  TError,
  { id: string; data: BodyType<CompleteServiceRequest> },
  TContext
> => {
  return useMutation(getCompleteServiceMutationOptions(options));
};

/**
 * @summary Driver rejects service
 */
export const getRejectServiceUrl = (id: string) => {
  return `/api/services/${id}/reject`;
};

export const rejectService = async (
  id: string,
  rejectServiceRequest: RejectServiceRequest,
  options?: RequestInit,
): Promise<ServiceDetail> => {
  return customFetch<ServiceDetail>(getRejectServiceUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(rejectServiceRequest),
  });
};

export const getRejectServiceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectService>>,
    TError,
    { id: string; data: BodyType<RejectServiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectService>>,
  TError,
  { id: string; data: BodyType<RejectServiceRequest> },
  TContext
> => {
  const mutationKey = ["rejectService"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectService>>,
    { id: string; data: BodyType<RejectServiceRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return rejectService(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectServiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof rejectService>>
>;
export type RejectServiceMutationBody = BodyType<RejectServiceRequest>;
export type RejectServiceMutationError = ErrorType<unknown>;

/**
 * @summary Driver rejects service
 */
export const useRejectService = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectService>>,
    TError,
    { id: string; data: BodyType<RejectServiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof rejectService>>,
  TError,
  { id: string; data: BodyType<RejectServiceRequest> },
  TContext
> => {
  return useMutation(getRejectServiceMutationOptions(options));
};

/**
 * @summary Report incident on service
 */
export const getReportIncidentUrl = (id: string) => {
  return `/api/services/${id}/incident`;
};

export const reportIncident = async (
  id: string,
  incidentRequest: IncidentRequest,
  options?: RequestInit,
): Promise<ServiceEvent> => {
  return customFetch<ServiceEvent>(getReportIncidentUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(incidentRequest),
  });
};

export const getReportIncidentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportIncident>>,
    TError,
    { id: string; data: BodyType<IncidentRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reportIncident>>,
  TError,
  { id: string; data: BodyType<IncidentRequest> },
  TContext
> => {
  const mutationKey = ["reportIncident"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reportIncident>>,
    { id: string; data: BodyType<IncidentRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return reportIncident(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReportIncidentMutationResult = NonNullable<
  Awaited<ReturnType<typeof reportIncident>>
>;
export type ReportIncidentMutationBody = BodyType<IncidentRequest>;
export type ReportIncidentMutationError = ErrorType<unknown>;

/**
 * @summary Report incident on service
 */
export const useReportIncident = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportIncident>>,
    TError,
    { id: string; data: BodyType<IncidentRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reportIncident>>,
  TError,
  { id: string; data: BodyType<IncidentRequest> },
  TContext
> => {
  return useMutation(getReportIncidentMutationOptions(options));
};

/**
 * @summary List legs for a service
 */
export const getListServiceLegsUrl = (id: string) => {
  return `/api/services/${id}/legs`;
};

export const listServiceLegs = async (
  id: string,
  options?: RequestInit,
): Promise<ServiceLegsResponse> => {
  return customFetch<ServiceLegsResponse>(getListServiceLegsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListServiceLegsQueryKey = (id: string) => {
  return [`/api/services/${id}/legs`] as const;
};

export const getListServiceLegsQueryOptions = <
  TData = Awaited<ReturnType<typeof listServiceLegs>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listServiceLegs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListServiceLegsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listServiceLegs>>> = ({
    signal,
  }) => listServiceLegs(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listServiceLegs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListServiceLegsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listServiceLegs>>
>;
export type ListServiceLegsQueryError = ErrorType<unknown>;

/**
 * @summary List legs for a service
 */

export function useListServiceLegs<
  TData = Awaited<ReturnType<typeof listServiceLegs>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listServiceLegs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListServiceLegsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create or replace legs for a service (logistics only)
 */
export const getReplaceServiceLegsUrl = (id: string) => {
  return `/api/services/${id}/legs`;
};

export const replaceServiceLegs = async (
  id: string,
  replaceLegsRequest: ReplaceLegsRequest,
  options?: RequestInit,
): Promise<ServiceLegsResponse> => {
  return customFetch<ServiceLegsResponse>(getReplaceServiceLegsUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(replaceLegsRequest),
  });
};

export const getReplaceServiceLegsMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof replaceServiceLegs>>,
    TError,
    { id: string; data: BodyType<ReplaceLegsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof replaceServiceLegs>>,
  TError,
  { id: string; data: BodyType<ReplaceLegsRequest> },
  TContext
> => {
  const mutationKey = ["replaceServiceLegs"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof replaceServiceLegs>>,
    { id: string; data: BodyType<ReplaceLegsRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return replaceServiceLegs(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReplaceServiceLegsMutationResult = NonNullable<
  Awaited<ReturnType<typeof replaceServiceLegs>>
>;
export type ReplaceServiceLegsMutationBody = BodyType<ReplaceLegsRequest>;
export type ReplaceServiceLegsMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create or replace legs for a service (logistics only)
 */
export const useReplaceServiceLegs = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof replaceServiceLegs>>,
    TError,
    { id: string; data: BodyType<ReplaceLegsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof replaceServiceLegs>>,
  TError,
  { id: string; data: BodyType<ReplaceLegsRequest> },
  TContext
> => {
  return useMutation(getReplaceServiceLegsMutationOptions(options));
};

/**
 * @summary Mark leg as en_camino (depart toward location)
 */
export const getLegDepartUrl = (id: string, legId: string) => {
  return `/api/services/${id}/legs/${legId}/depart`;
};

export const legDepart = async (
  id: string,
  legId: string,
  options?: RequestInit,
): Promise<ServiceLeg> => {
  return customFetch<ServiceLeg>(getLegDepartUrl(id, legId), {
    ...options,
    method: "PATCH",
  });
};

export const getLegDepartMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof legDepart>>,
    TError,
    { id: string; legId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof legDepart>>,
  TError,
  { id: string; legId: string },
  TContext
> => {
  const mutationKey = ["legDepart"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof legDepart>>,
    { id: string; legId: string }
  > = (props) => {
    const { id, legId } = props ?? {};

    return legDepart(id, legId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LegDepartMutationResult = NonNullable<
  Awaited<ReturnType<typeof legDepart>>
>;

export type LegDepartMutationError = ErrorType<unknown>;

/**
 * @summary Mark leg as en_camino (depart toward location)
 */
export const useLegDepart = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof legDepart>>,
    TError,
    { id: string; legId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof legDepart>>,
  TError,
  { id: string; legId: string },
  TContext
> => {
  return useMutation(getLegDepartMutationOptions(options));
};

/**
 * @summary Mark leg as en_sitio (arrived at location)
 */
export const getLegArriveUrl = (id: string, legId: string) => {
  return `/api/services/${id}/legs/${legId}/arrive`;
};

export const legArrive = async (
  id: string,
  legId: string,
  arrivalRequest?: ArrivalRequest,
  options?: RequestInit,
): Promise<ServiceLeg> => {
  return customFetch<ServiceLeg>(getLegArriveUrl(id, legId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(arrivalRequest),
  });
};

export const getLegArriveMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof legArrive>>,
    TError,
    { id: string; legId: string; data: BodyType<ArrivalRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof legArrive>>,
  TError,
  { id: string; legId: string; data: BodyType<ArrivalRequest> },
  TContext
> => {
  const mutationKey = ["legArrive"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof legArrive>>,
    { id: string; legId: string; data: BodyType<ArrivalRequest> }
  > = (props) => {
    const { id, legId, data } = props ?? {};

    return legArrive(id, legId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LegArriveMutationResult = NonNullable<
  Awaited<ReturnType<typeof legArrive>>
>;
export type LegArriveMutationBody = BodyType<ArrivalRequest>;
export type LegArriveMutationError = ErrorType<unknown>;

/**
 * @summary Mark leg as en_sitio (arrived at location)
 */
export const useLegArrive = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof legArrive>>,
    TError,
    { id: string; legId: string; data: BodyType<ArrivalRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof legArrive>>,
  TError,
  { id: string; legId: string; data: BodyType<ArrivalRequest> },
  TContext
> => {
  return useMutation(getLegArriveMutationOptions(options));
};

/**
 * @summary Mark leg as completado
 */
export const getLegCompleteUrl = (id: string, legId: string) => {
  return `/api/services/${id}/legs/${legId}/complete`;
};

export const legComplete = async (
  id: string,
  legId: string,
  legCompleteRequest?: LegCompleteRequest,
  options?: RequestInit,
): Promise<ServiceLeg> => {
  return customFetch<ServiceLeg>(getLegCompleteUrl(id, legId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(legCompleteRequest),
  });
};

export const getLegCompleteMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof legComplete>>,
    TError,
    { id: string; legId: string; data: BodyType<LegCompleteRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof legComplete>>,
  TError,
  { id: string; legId: string; data: BodyType<LegCompleteRequest> },
  TContext
> => {
  const mutationKey = ["legComplete"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof legComplete>>,
    { id: string; legId: string; data: BodyType<LegCompleteRequest> }
  > = (props) => {
    const { id, legId, data } = props ?? {};

    return legComplete(id, legId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LegCompleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof legComplete>>
>;
export type LegCompleteMutationBody = BodyType<LegCompleteRequest>;
export type LegCompleteMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Mark leg as completado
 */
export const useLegComplete = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof legComplete>>,
    TError,
    { id: string; legId: string; data: BodyType<LegCompleteRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof legComplete>>,
  TError,
  { id: string; legId: string; data: BodyType<LegCompleteRequest> },
  TContext
> => {
  return useMutation(getLegCompleteMutationOptions(options));
};

/**
 * @summary List events for a service
 */
export const getListServiceEventsUrl = (id: string) => {
  return `/api/services/${id}/events`;
};

export const listServiceEvents = async (
  id: string,
  options?: RequestInit,
): Promise<ServiceEventListResponse> => {
  return customFetch<ServiceEventListResponse>(getListServiceEventsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListServiceEventsQueryKey = (id: string) => {
  return [`/api/services/${id}/events`] as const;
};

export const getListServiceEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof listServiceEvents>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listServiceEvents>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListServiceEventsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listServiceEvents>>
  > = ({ signal }) => listServiceEvents(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listServiceEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListServiceEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listServiceEvents>>
>;
export type ListServiceEventsQueryError = ErrorType<unknown>;

/**
 * @summary List events for a service
 */

export function useListServiceEvents<
  TData = Awaited<ReturnType<typeof listServiceEvents>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listServiceEvents>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListServiceEventsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get presigned URL for file upload
 */
export const getGetPresignedUrlUrl = () => {
  return `/api/upload/presign`;
};

export const getPresignedUrl = async (
  presignRequest: PresignRequest,
  options?: RequestInit,
): Promise<PresignResponse> => {
  return customFetch<PresignResponse>(getGetPresignedUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(presignRequest),
  });
};

export const getGetPresignedUrlMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPresignedUrl>>,
    TError,
    { data: BodyType<PresignRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getPresignedUrl>>,
  TError,
  { data: BodyType<PresignRequest> },
  TContext
> => {
  const mutationKey = ["getPresignedUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getPresignedUrl>>,
    { data: BodyType<PresignRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return getPresignedUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetPresignedUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof getPresignedUrl>>
>;
export type GetPresignedUrlMutationBody = BodyType<PresignRequest>;
export type GetPresignedUrlMutationError = ErrorType<unknown>;

/**
 * @summary Get presigned URL for file upload
 */
export const useGetPresignedUrl = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPresignedUrl>>,
    TError,
    { data: BodyType<PresignRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getPresignedUrl>>,
  TError,
  { data: BodyType<PresignRequest> },
  TContext
> => {
  return useMutation(getGetPresignedUrlMutationOptions(options));
};

/**
 * @summary Get dashboard summary metrics
 */
export const getGetDashboardSummaryUrl = (
  params?: GetDashboardSummaryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/summary?${stringifiedParams}`
    : `/api/dashboard/summary`;
};

export const getDashboardSummary = async (
  params?: GetDashboardSummaryParams,
  options?: RequestInit,
): Promise<DashboardSummary> => {
  return customFetch<DashboardSummary>(getGetDashboardSummaryUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetDashboardSummaryQueryKey = (
  params?: GetDashboardSummaryParams,
) => {
  return [`/api/dashboard/summary`, ...(params ? [params] : [])] as const;
};

export const getGetDashboardSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDashboardSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDashboardSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDashboardSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardSummary>>
  > = ({ signal }) =>
    getDashboardSummary(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDashboardSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardSummary>>
>;
export type GetDashboardSummaryQueryError = ErrorType<unknown>;

/**
 * @summary Get dashboard summary metrics
 */

export function useGetDashboardSummary<
  TData = Awaited<ReturnType<typeof getDashboardSummary>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDashboardSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDashboardSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDashboardSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get services count grouped by day
 */
export const getGetServicesByDayUrl = (params?: GetServicesByDayParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/services-by-day?${stringifiedParams}`
    : `/api/dashboard/services-by-day`;
};

export const getServicesByDay = async (
  params?: GetServicesByDayParams,
  options?: RequestInit,
): Promise<ServicesByDayResponse> => {
  return customFetch<ServicesByDayResponse>(getGetServicesByDayUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetServicesByDayQueryKey = (
  params?: GetServicesByDayParams,
) => {
  return [
    `/api/dashboard/services-by-day`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetServicesByDayQueryOptions = <
  TData = Awaited<ReturnType<typeof getServicesByDay>>,
  TError = ErrorType<unknown>,
>(
  params?: GetServicesByDayParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getServicesByDay>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetServicesByDayQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getServicesByDay>>
  > = ({ signal }) => getServicesByDay(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getServicesByDay>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetServicesByDayQueryResult = NonNullable<
  Awaited<ReturnType<typeof getServicesByDay>>
>;
export type GetServicesByDayQueryError = ErrorType<unknown>;

/**
 * @summary Get services count grouped by day
 */

export function useGetServicesByDay<
  TData = Awaited<ReturnType<typeof getServicesByDay>>,
  TError = ErrorType<unknown>,
>(
  params?: GetServicesByDayParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getServicesByDay>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetServicesByDayQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get services distribution by type
 */
export const getGetServicesByTypeUrl = (params?: GetServicesByTypeParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/services-by-type?${stringifiedParams}`
    : `/api/dashboard/services-by-type`;
};

export const getServicesByType = async (
  params?: GetServicesByTypeParams,
  options?: RequestInit,
): Promise<ServicesByTypeResponse> => {
  return customFetch<ServicesByTypeResponse>(getGetServicesByTypeUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetServicesByTypeQueryKey = (
  params?: GetServicesByTypeParams,
) => {
  return [
    `/api/dashboard/services-by-type`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetServicesByTypeQueryOptions = <
  TData = Awaited<ReturnType<typeof getServicesByType>>,
  TError = ErrorType<unknown>,
>(
  params?: GetServicesByTypeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getServicesByType>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetServicesByTypeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getServicesByType>>
  > = ({ signal }) => getServicesByType(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getServicesByType>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetServicesByTypeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getServicesByType>>
>;
export type GetServicesByTypeQueryError = ErrorType<unknown>;

/**
 * @summary Get services distribution by type
 */

export function useGetServicesByType<
  TData = Awaited<ReturnType<typeof getServicesByType>>,
  TError = ErrorType<unknown>,
>(
  params?: GetServicesByTypeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getServicesByType>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetServicesByTypeQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get top clients by service count
 */
export const getGetTopClientsUrl = (params?: GetTopClientsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/top-clients?${stringifiedParams}`
    : `/api/dashboard/top-clients`;
};

export const getTopClients = async (
  params?: GetTopClientsParams,
  options?: RequestInit,
): Promise<TopClientsResponse> => {
  return customFetch<TopClientsResponse>(getGetTopClientsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetTopClientsQueryKey = (params?: GetTopClientsParams) => {
  return [`/api/dashboard/top-clients`, ...(params ? [params] : [])] as const;
};

export const getGetTopClientsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopClients>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTopClientsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTopClients>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTopClientsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTopClients>>> = ({
    signal,
  }) => getTopClients(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopClients>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTopClientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopClients>>
>;
export type GetTopClientsQueryError = ErrorType<unknown>;

/**
 * @summary Get top clients by service count
 */

export function useGetTopClients<
  TData = Awaited<ReturnType<typeof getTopClients>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTopClientsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTopClients>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTopClientsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get expiring documents (licenses, permits, VTV)
 */
export const getGetExpiringDocumentsUrl = (
  params?: GetExpiringDocumentsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/expiring-documents?${stringifiedParams}`
    : `/api/dashboard/expiring-documents`;
};

export const getExpiringDocuments = async (
  params?: GetExpiringDocumentsParams,
  options?: RequestInit,
): Promise<ExpiringDocumentsResponse> => {
  return customFetch<ExpiringDocumentsResponse>(
    getGetExpiringDocumentsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetExpiringDocumentsQueryKey = (
  params?: GetExpiringDocumentsParams,
) => {
  return [
    `/api/dashboard/expiring-documents`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetExpiringDocumentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getExpiringDocuments>>,
  TError = ErrorType<unknown>,
>(
  params?: GetExpiringDocumentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getExpiringDocuments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetExpiringDocumentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getExpiringDocuments>>
  > = ({ signal }) =>
    getExpiringDocuments(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getExpiringDocuments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetExpiringDocumentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExpiringDocuments>>
>;
export type GetExpiringDocumentsQueryError = ErrorType<unknown>;

/**
 * @summary Get expiring documents (licenses, permits, VTV)
 */

export function useGetExpiringDocuments<
  TData = Awaited<ReturnType<typeof getExpiringDocuments>>,
  TError = ErrorType<unknown>,
>(
  params?: GetExpiringDocumentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getExpiringDocuments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetExpiringDocumentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get daily schedule (services grouped for timeline)
 */
export const getGetDailyScheduleUrl = (params: GetDailyScheduleParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/schedule?${stringifiedParams}`
    : `/api/dashboard/schedule`;
};

export const getDailySchedule = async (
  params: GetDailyScheduleParams,
  options?: RequestInit,
): Promise<DailyScheduleResponse> => {
  return customFetch<DailyScheduleResponse>(getGetDailyScheduleUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetDailyScheduleQueryKey = (
  params?: GetDailyScheduleParams,
) => {
  return [`/api/dashboard/schedule`, ...(params ? [params] : [])] as const;
};

export const getGetDailyScheduleQueryOptions = <
  TData = Awaited<ReturnType<typeof getDailySchedule>>,
  TError = ErrorType<unknown>,
>(
  params: GetDailyScheduleParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDailySchedule>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDailyScheduleQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDailySchedule>>
  > = ({ signal }) => getDailySchedule(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDailySchedule>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDailyScheduleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDailySchedule>>
>;
export type GetDailyScheduleQueryError = ErrorType<unknown>;

/**
 * @summary Get daily schedule (services grouped for timeline)
 */

export function useGetDailySchedule<
  TData = Awaited<ReturnType<typeof getDailySchedule>>,
  TError = ErrorType<unknown>,
>(
  params: GetDailyScheduleParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDailySchedule>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDailyScheduleQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Cancel service
 */
export const getCancelServiceUrl = (id: string) => {
  return `/api/services/${id}/cancel`;
};

export const cancelService = async (
  id: string,
  cancelServiceRequest: CancelServiceRequest,
  options?: RequestInit,
): Promise<ServiceDetail> => {
  return customFetch<ServiceDetail>(getCancelServiceUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(cancelServiceRequest),
  });
};

export const getCancelServiceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelService>>,
    TError,
    { id: string; data: BodyType<CancelServiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelService>>,
  TError,
  { id: string; data: BodyType<CancelServiceRequest> },
  TContext
> => {
  const mutationKey = ["cancelService"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelService>>,
    { id: string; data: BodyType<CancelServiceRequest> }
  > = (props) => {
    const { id, data } = props ?? {};
    return cancelService(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelServiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelService>>
>;
export type CancelServiceMutationBody = BodyType<CancelServiceRequest>;
export type CancelServiceMutationError = ErrorType<unknown>;

export const useCancelService = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelService>>,
    TError,
    { id: string; data: BodyType<CancelServiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelService>>,
  TError,
  { id: string; data: BodyType<CancelServiceRequest> },
  TContext
> => {
  return useMutation(getCancelServiceMutationOptions(options));
};

/**
 * @summary Reschedule service
 */
export const getRescheduleServiceUrl = (id: string) => {
  return `/api/services/${id}/reschedule`;
};

export const rescheduleService = async (
  id: string,
  rescheduleServiceRequest: RescheduleServiceRequest,
  options?: RequestInit,
): Promise<RescheduleServiceResponse> => {
  return customFetch<RescheduleServiceResponse>(getRescheduleServiceUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(rescheduleServiceRequest),
  });
};

export const getRescheduleServiceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rescheduleService>>,
    TError,
    { id: string; data: BodyType<RescheduleServiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rescheduleService>>,
  TError,
  { id: string; data: BodyType<RescheduleServiceRequest> },
  TContext
> => {
  const mutationKey = ["rescheduleService"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rescheduleService>>,
    { id: string; data: BodyType<RescheduleServiceRequest> }
  > = (props) => {
    const { id, data } = props ?? {};
    return rescheduleService(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RescheduleServiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof rescheduleService>>
>;
export type RescheduleServiceMutationBody = BodyType<RescheduleServiceRequest>;
export type RescheduleServiceMutationError = ErrorType<unknown>;

export const useRescheduleService = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rescheduleService>>,
    TError,
    { id: string; data: BodyType<RescheduleServiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof rescheduleService>>,
  TError,
  { id: string; data: BodyType<RescheduleServiceRequest> },
  TContext
> => {
  return useMutation(getRescheduleServiceMutationOptions(options));
};
